import { Main, Split, Bottoms } from '@styles/components/ModalBodyStyle';
import * as S from '@styles/components/FormStyle';
import { MakerTypes } from '@typedef/components/Device/Maker/maker.types';

type Props = {
  type: string;
  inputs: Partial<MakerTypes>;
  onChangeInputs: (e: { target: HTMLInputElement }) => void;
  save: () => Promise<void>;
};

const MakerManage = ({ type, inputs, onChangeInputs, save }: Props) => {
  return (
    <Main width={35}>
      <Split>
        <S.InputBox isRow>
          <p>
            제조사명<span>*</span>
          </p>
          <S.Input
            name='name'
            onChange={onChangeInputs}
            defaultValue={inputs.name}
            placeholder='제조사명'
          />
        </S.InputBox>
      </Split>
      <Bottoms>
        <button type='button' onClick={save} disabled={!!!inputs.name}>
          제조사 {type}하기
        </button>
      </Bottoms>
    </Main>
  );
};

export default MakerManage;
